export class Notification {
    chatId: string
    title: string
    image: string
    body: string
    userId: string
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/notification/shared/notification.model.ts